import React from 'react';
import { Venture } from '../types/venture';
interface WordmarkProps {
  name: string;
  mark: Venture['mark'];
  className?: string;
}

/**
 * Monochrome typographic wordmarks. Every mark inherits currentColor so the
 * logo wall can stay a single ink weight and shift on hover.
 */
export function Wordmark({
  name,
  mark,
  className = ''
}: WordmarkProps) {
  const base = `inline-flex items-center leading-none ${className}`;
  if (mark === 'caps') {
    return <span className={`${base} font-sans text-[15px] font-semibold uppercase tracking-[0.22em]`} data-id="element-112" data-mp="3621yeig7j58o">
        {name}
      </span>;
  }
  if (mark === 'serif') {
    return <span className={`${base} font-serif text-[26px] italic tracking-tight`} data-id="element-113" data-mp="3ez2iwe05oj6u">{name}</span>;
  }
  if (mark === 'lowercase') {
    return <span className={`${base} font-sans text-[24px] font-semibold lowercase tracking-[-0.04em]`} data-id="element-114" data-mp="uaeqt2ptz8bp">
        {name}
      </span>;
  }
  if (mark === 'mono') {
    return <span className={`${base} gap-2 font-mono text-[13px] font-medium uppercase tracking-[0.1em]`} data-id="element-115" data-mp="zb2jrtxmdz8k">
        <span aria-hidden="true" className="h-[9px] w-[9px] border border-current" data-id="element-116" data-mp="14lp2rs0mo0bu" />
        {name}
      </span>;
  }
  if (mark === 'dotted') {
    return <span className={`${base} gap-[6px] font-sans text-[20px] font-medium tracking-[-0.02em]`} data-id="element-117" data-mp="zl12sguf895h">
        {name}
        <span aria-hidden="true" className="mb-[3px] h-[5px] w-[5px] self-end rounded-full bg-current" data-id="element-118" data-mp="un96zbqno2w0" />
      </span>;
  }
  return <span className={`${base} gap-[7px] font-sans text-[19px] font-medium tracking-[-0.01em]`} data-id="element-119" data-mp="lvh35jw4zs0e">
      <span aria-hidden="true" className="flex flex-col gap-[3px]" data-id="element-120" data-mp="gvupxagb6brl">
        <span className="block h-[2px] w-[14px] bg-current" data-id="element-121" data-mp="gu05rycv2nok" />
        <span className="block h-[2px] w-[9px] bg-current" data-id="element-122" data-mp="by2qzwh8xpdw" />
      </span>
      {name}
    </span>;
}